import { getMementoKey } from './getMementoKey';
import { isMementoAvailable } from './isMementoAvailable';

export const clearMemento = (id: string, platform: string) => {
  if (isMementoAvailable(id, platform)) {
    window.localStorage.removeItem(getMementoKey(id, platform));
  }
};
